export type BatchWorkspaceTabContentActions =
  | BatchWorkspaceProductTypeSelected
  | BatchWorkspaceProductSelected
  | BatchWorkspaceProductSubTypeSelected
  | BatchWorkspaceWrapperSelected
  | ToggleBatchWorkspaceMultipleApply
  | BatchMultipleApplySetSelectedFields
  | BatchMultipleApplySetFieldValue
  | BatchMultipleApplySetFieldAction
  | BatchMultipleApplyClearFieldValue
  | BatchToggleDeleteFormConfirmationModal;

export function batchWorkspaceProductTypeSelected(tabId: string, productType: string) {
  return {
    type: 'NEW_BATCH_WORKSPACE_PRODUCT_TYPE_SELECTED' as const,
    tabId,
    productType,
  };
}
export type BatchWorkspaceProductTypeSelected = ReturnType<typeof batchWorkspaceProductTypeSelected>;

export function batchWorkspaceProductSubTypeSelected(tabId: string, productSubType: string) {
  return {
    type: 'NEW_BATCH_WORKSPACE_PRODUCT_SUBTYPE_SELECTED' as const,
    tabId,
    productSubType,
  };
}
export type BatchWorkspaceProductSubTypeSelected = ReturnType<typeof batchWorkspaceProductSubTypeSelected>;

export function batchWorkspaceWrapperSelected(tabId: string, wrapper: string) {
  return {
    type: 'NEW_BATCH_WORKSPACE_WRAPPER_SELECTED' as const,
    tabId,
    wrapper,
  };
}
export type BatchWorkspaceWrapperSelected = ReturnType<typeof batchWorkspaceWrapperSelected>;

export function batchWorkspaceProductSelected(
  tabId: string,
  productType: string,
  productSubType: string,
  wrapper: string,
  payoffType?: string,
) {
  return {
    type: 'NEW_BATCH_WORKSPACE_PRODUCT_SELECTED' as const,
    tabId,
    productType,
    productSubType,
    wrapper,
    payoffType,
  };
}
export type BatchWorkspaceProductSelected = ReturnType<typeof batchWorkspaceProductSelected>;

export function toggleBatchWorkspaceMultipleApply(tabId: string, isOpen: boolean) {
  return {
    type: 'NEW_BATCH_WORKSPACE_TOGGLE_MULTIPLE_APPLY' as const,
    tabId,
    isOpen,
  };
}
export type ToggleBatchWorkspaceMultipleApply = ReturnType<typeof toggleBatchWorkspaceMultipleApply>;

export function batchMultipleApplySetSelectedFields(tabId: string, selectedFieldsIds: readonly string[]) {
  return {
    type: 'BATCH_MULTIPLE_APPLY_SET_SELECTED_FIELDS' as const,
    tabId,
    selectedFieldsIds,
  };
}

export type BatchMultipleApplySetSelectedFields = ReturnType<typeof batchMultipleApplySetSelectedFields>;

export function batchMultipleApplySetFieldValue(tabId: string, fieldId: string, value: Readonly<unknown>) {
  return {
    type: 'BATCH_MULTIPLE_APPLY_SET_FIELD_VALUE' as const,
    tabId,
    fieldId,
    value,
  };
}

export type BatchMultipleApplySetFieldValue = ReturnType<typeof batchMultipleApplySetFieldValue>;

export function batchMultipleApplyClearFieldValue(tabId: string) {
  return {
    type: 'BATCH_MULTIPLE_APPLY_CLEAR_FIELD_VALUE' as const,
    tabId,
  };
}

export type BatchMultipleApplyClearFieldValue = ReturnType<typeof batchMultipleApplyClearFieldValue>;

export function batchMultipleApplySetFieldAction(tabId: string, fieldId: string, value: 'add' | 'replace') {
  return {
    type: 'BATCH_MULTIPLE_APPLY_SET_FIELD_ACTION' as const,
    tabId,
    fieldId,
    value,
  };
}

export type BatchMultipleApplySetFieldAction = ReturnType<typeof batchMultipleApplySetFieldAction>;

export function batchToggleDeleteFormConfirmationModal(tabId: string, isOpen: boolean) {
  return {
    type: 'BATCH_TOGGLE_DELETE_FORM_CONFIRMATION_MODAL' as const,
    tabId,
    isOpen,
  };
}

export type BatchToggleDeleteFormConfirmationModal = ReturnType<typeof batchToggleDeleteFormConfirmationModal>;
